import { action } from 'easy-peasy';
import { setCrisisReportFilter } from '~/services/localStorage/filters';
import { IActionSetCrisisReportFilters } from '../types';

const setCrisisReportFilters: IActionSetCrisisReportFilters = action((state, payload) => {
  const updatedFilters = { ...state.crisisReport.filters, ...payload };

  setCrisisReportFilter(updatedFilters);
  state.crisisReport.filters = updatedFilters;
});

export default setCrisisReportFilters;
